import React from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { connect } from "react-redux";
// import { Div, BigFilledButton, BigOutlineButton } from "components/Base";

// import {
//   getSectionHeaderColor,
//   getSectionHeaderFont,
//   getSectionHeaderSize
// } from "Portal/NewPortal/PortalHome/selectors";

import { FIELDS_ID } from "../constants";

import { actions, getters } from "../model";
import styles from "./styles.scss";

import { noop, isEmptyOrNil } from "utils/General";

// import {
//   getPortalUserName,
//   getPortalUserEmail,
//   getPortalUserPhoto
// } from "Portal/NewPortal/HeaderBar/selectors";
// import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";

import { Calendar, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import EventList from "./EventList";

import EventSwitcher from "Portal/NewPortal/Shared/EventSwitcher";

import { getCalendarData } from "../selectors";

import { Default } from "Portal/NewPortal/Shared/MediasQuery";
import { CheckboxInput } from "ui-kit/Form/View";

const decorate = R.compose(
  connect(
    state => ({
      // sectionHeaderColor: getSectionHeaderColor(state),
      // sectionHeaderFont: getSectionHeaderFont(state),
      // sectionHeaderSize: getSectionHeaderSize(state),
      // backgroundColor: getBackgroundColor(state),

      calendarData: getCalendarData(state),
      selectedDate: getters.selectedDate(state)
    }),
    {
      //   init: actions.init,
      handleDateChange: date => actions.setSelectedDate(date)
    }
  ),
  CSSModules(styles)
);

const Body = ({
  //   init = noop,
  calendarData = {},
  handleDateChange = noop,
  selectedDate = null
}) => {
  //   useEffect(() => {
  //     init();
  //   }, []);

  if (isEmptyOrNil(selectedDate)) {
    return null;
  }

  return (
    <>
      <Default>
        <div className={styles.profileContainer}>
          <div className={styles.leftContainer}>
            <div className={styles.titleContainer}>
              <div className={styles.title}>Calendar</div>
            </div>
            <div className={styles.calendarContainer}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <Calendar date={selectedDate} onChange={handleDateChange} />
              </MuiPickersUtilsProvider>
            </div>
            <div className={styles.eventsOptionsContainer}>
              <div className={styles.innerContainer}>
                <div className={styles.item}>
                  <div className={styles.iconContainer}>
                    <CheckboxInput fieldId={FIELDS_ID.TASKS} iniValue={false} />
                  </div>
                  <div className={styles.smallIcon}></div>
                  <div className={styles.textContainer}>
                    <div className={styles.text}>Tasks</div>
                  </div>
                </div>
                <div className={styles.stretchItem}>
                  <div className={styles.iconContainer}>
                    <CheckboxInput
                      fieldId={FIELDS_ID.EVENTS}
                      iniValue={false}
                    />
                  </div>
                  <div className={styles.smallIconBlue}></div>
                  <div className={styles.textContainer}>
                    <div className={styles.text}>Events</div>
                  </div>
                </div>
              </div>
              <div className={styles.stretchContainer}>
                <div className={styles.flexContainer}>
                  <EventSwitcher fieldId={FIELDS_ID.EVENT_FILTER} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.rightContainer}>
            <div className={styles.titleContainer}>
              <div className={styles.title}>Upcoming Events</div>
            </div>
            {!isEmptyOrNil(calendarData) && (
              <EventList calendarData={calendarData} />
            )}
            {isEmptyOrNil(calendarData) && (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "18px"
                }}
              >
                You don't have upcoming events.
              </div>
            )}
          </div>
        </div>
      </Default>
    </>
  );
};

export default decorate(Body);
